import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Typography } from "@/components/ui/Typography";
import type { FooterSectionStoryblok } from "@/generated/sb/sb-types";

export const FooterSectionBlok = ({ blok, preview }: BlokProps<FooterSectionStoryblok>) => {
	return (
		<BlokWrap
			editable={blok}
			as="div"
			className="flex flex-col gap-grid-component-spacing-md mx-grid-section-horizontal-margin-page-base lg:mx-0 lg:gap-5"
		>
			<Typography variant="label-sm-reg" className="text-text-sand-text-3 text-xs">
				{blok.header}
			</Typography>
			{blok.links?.map((link, j) => (
				<StoryblokComponent
					blok={link}
					key={j}
					preview={preview}
					className="font-body font-regular text-[16px] tabular-nums lining-nums text-text-sand-text-2"
					rightIcon={false}
					light
					unstyled={link.component !== "phoneLink"}
				/>
			))}
		</BlokWrap>
	);
};
